var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade"}},[_c('CookieAlert')],1),_c('BaseHeader'),_c('BaseLine'),_c('BaseLineModal'),_c('router-view',{staticClass:"router-view-layout"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }